import { useEffect } from 'react';

export const useOnValueSet = (effect: () => void, value: any | null | undefined): void => {
    useEffect(() => {
        if (value) {
            effect();
        }
    }, [ value ]);
};
